module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/3_a02841518efc75280a3d38c578d787e9.png";